interface Props {
  message: string | null;
  onDismiss?: () => void;
}

export function Toast({ message, onDismiss }: Props) {
  if (!message) return null;
  return (
    <div className="toast" role="status" onClick={onDismiss}>
      {message}
    </div>
  );
}
